import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GetDestinosWebService } from '../shared/services/web/get-destinos-web.service';

@Injectable({
	providedIn: 'root'
})
export class destinosGuard implements CanActivate {
	constructor(private _destinoApiResource: GetDestinosWebService, private router: Router) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		const slug = route.paramMap.get('slug');

		if (!slug) {
			this.router.navigate(['/error']);
			return of(false);
		}

		return this._destinoApiResource.getDestino(slug).pipe(
			map((data) => {
				if (data) {
					// Almacena la información en la propiedad 'data' de la ruta
					route.data = { ...route.data, pageData: data };
					return true;
				}
				this.router.navigate(['/page-not-found']);
				return false;
			}),
			catchError(() => {
				this.router.navigate(['/page-not-found']);
				return of(false);
			})
		);
	}
}
